"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FeDefaultLink = _interopRequireDefault(require("./FeDefaultLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeAppLogo = function FeAppLogo(_ref) {
  var product = _ref.product,
      brandName = _ref.brandName,
      route = _ref.route,
      href = _ref.href,
      customRenderLink = _ref.customRenderLink;
  var Link = customRenderLink || _FeDefaultLink.default;
  return _react.default.createElement(Link, {
    className: "fe-top-nav__home",
    route: route,
    href: href
  }, _react.default.createElement("span", {
    className: "fe-top-nav__logo"
  }), _react.default.createElement("span", {
    className: "fe-top-nav__product"
  }, product));
};

FeAppLogo.propTypes = {
  /** The FireEye product name of the application */
  product: _propTypes.default.string.isRequired,

  /** The React Router route (relative or absolute) to visit when clicking the logo */
  route: _propTypes.default.string,

  /** The link (not using React Router) to visit when clicking the logo */
  href: _propTypes.default.string,

  /** A function that returns a react element to render the wrapping link.
   *  Will receive url, className, and children props
   */
  customRenderLink: _propTypes.default.func
};
var _default = FeAppLogo;
exports.default = _default;